<script>
export default {
    name: "Socials",
    methods: {
        openLink(link) {
            if (link) {
                window.open(link, '_blank')
            } else {
                console.error('Нет ссылки')
            }
        }
    },
}
</script>

<template>
<section class="socials">
    <div class="social-image"></div>
    <div class="social-container">
        <div class="socials-text-container">
            <div class="social-title">{{__('Подписывайтесь на наши соц. сети')}}</div>
            <div class="social-desc">{{__('В них делимся новостями о приложении, проводим опросы, общаемся с игроками и помогаем, если возникнут проблемы.')}}</div>
        </div>
        <div class="social-wrapper-container">
        <div class="social-wrapper">
            <div class="social-card discord" @click="openLink('https://discord.gg/MCSkQab2EB')">
                <svg width="140" height="28" viewBox="0 0 140 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M47 7.66016H54.5137C56.3247 7.66016 57.8568 7.94783 59.11 8.52317C60.2638 9.01701 61.2436 9.85521 61.9201 10.9273C62.5534 11.9864 62.8779 13.2069 62.8559 14.4466C62.8698 15.692 62.5326 16.9153 61.8843 17.9715C61.1611 19.0873 60.127 19.9576 58.9146 20.4709C57.5862 21.0873 55.9394 21.3946 53.9743 21.3927H47V7.66016ZM53.8972 17.8986C55.1174 17.8986 56.055 17.5885 56.71 16.9684C57.0422 16.6405 57.3017 16.2441 57.4711 15.8058C57.6406 15.3675 57.7161 14.8974 57.6926 14.427C57.713 13.9903 57.646 13.554 57.4955 13.1445C57.345 12.7351 57.1143 12.3611 56.8174 12.0453C56.2302 11.4513 55.3467 11.1533 54.1669 11.1514H51.8165V17.8986H53.8972Z" fill="white"/>
                <path d="M74.1077 21.3706C73.1165 21.1178 72.1683 20.7144 71.2949 20.1742V16.9183C72.0574 17.4829 72.9159 17.8989 73.827 18.1455C74.8238 18.4552 75.8592 18.6165 76.9013 18.6247C77.261 18.6442 77.6203 18.581 77.9527 18.4397C78.1894 18.3165 78.3077 18.1595 78.3077 17.997C78.3103 17.9062 78.2945 17.8159 78.2613 17.7315C78.2282 17.6472 78.1784 17.5707 78.1151 17.5067C77.8952 17.3345 77.6372 17.22 77.3637 17.1732L75.0518 16.6437C73.727 16.3298 72.7867 15.8955 72.2307 15.3407C71.9516 15.0542 71.7341 14.7116 71.5919 14.3349C71.4498 13.9582 71.3861 13.5555 71.405 13.1524C71.3957 12.4218 71.6571 11.7145 72.1371 11.1714C72.7062 10.5585 73.4239 10.1091 74.2178 9.86845C75.2396 9.5415 76.3066 9.38537 77.3775 9.40612C78.3771 9.39657 79.3739 9.51518 80.3444 9.75918C81.1283 9.94826 81.8811 10.2522 82.5793 10.6614V13.7436C81.9245 13.3569 81.2207 13.0637 80.4875 12.8722C79.6932 12.6553 78.8742 12.5461 78.0518 12.5472C76.8444 12.5472 76.2408 12.7564 76.2408 13.1748C76.2388 13.268 76.2638 13.3597 76.3128 13.4384C76.3617 13.5172 76.4324 13.5795 76.516 13.6175C76.8459 13.7603 77.1915 13.8619 77.5453 13.9201L79.4719 14.2732C80.7233 14.4973 81.6563 14.8896 82.271 15.45C82.8857 16.0104 83.1939 16.8305 83.1958 17.9102C83.2055 18.4779 83.0692 19.0384 82.8002 19.5359C82.5313 20.0333 82.1391 20.4505 81.6627 20.7458C80.6481 21.4388 79.1995 21.7844 77.3169 21.7825C76.2344 21.7842 75.156 21.6458 74.1077 21.3706Z" fill="white"/>
                <path d="M87.7476 20.9579C86.7176 20.476 85.8495 19.6965 85.2513 18.7163C84.6933 17.755 84.4075 16.6552 84.4256 15.5388C84.409 14.423 84.7101 13.3263 85.2926 12.381C85.9134 11.4161 86.7972 10.6566 87.8357 10.1954C89.0983 9.6353 90.4662 9.36368 91.843 9.39964C93.7696 9.39964 95.3687 9.81154 96.6402 10.6353V14.2303C96.1565 13.8992 95.628 13.6415 95.0714 13.4653C94.4483 13.2651 93.7982 13.1658 93.1448 13.1711C91.9503 13.1711 91.0155 13.3934 90.3403 13.838C90.0367 14.0105 89.7835 14.2617 89.6063 14.5662C89.4291 14.8706 89.3343 15.2174 89.3315 15.5713C89.3287 15.9252 89.418 16.2735 89.5904 16.5808C89.7627 16.8881 90.012 17.1435 90.3127 17.3209C90.9678 17.7711 91.9182 17.9962 93.1641 17.9962C93.8072 17.9977 94.447 17.9033 95.0632 17.716C95.6252 17.5519 96.1651 17.3175 96.6705 17.0183V20.4927C95.1813 21.3767 93.4811 21.8247 91.7577 21.7873C90.3764 21.8256 89.0047 21.5419 87.7476 20.9579Z" fill="white"/>
                <path d="M101.438 20.9583C100.396 20.4741 99.5125 19.6962 98.8917 18.7167C98.3066 17.7577 98.003 16.6485 98.0164 15.5196C97.9978 14.4042 98.3022 13.3078 98.8917 12.3674C99.5158 11.4128 100.395 10.6602 101.427 10.1987C103.959 9.15253 106.793 9.15253 109.326 10.1987C110.353 10.6567 111.229 11.4056 111.849 12.3562C112.435 13.3001 112.736 14.3978 112.716 15.514C112.73 16.6417 112.429 17.7503 111.849 18.7111C111.235 19.6913 110.356 20.4698 109.317 20.9527C108.072 21.4962 106.732 21.7765 105.377 21.7765C104.023 21.7765 102.682 21.4962 101.438 20.9527V20.9583ZM107.292 17.4782C107.53 17.2281 107.715 16.931 107.836 16.6053C107.957 16.2795 108.012 15.932 107.996 15.5841C108.013 15.2394 107.959 14.895 107.837 14.5727C107.716 14.2505 107.53 13.9574 107.292 13.7124C107.033 13.4707 106.729 13.2844 106.398 13.1645C106.067 13.0447 105.716 12.9937 105.365 13.0147C105.015 12.9959 104.664 13.0479 104.333 13.1676C104.003 13.2874 103.699 13.4725 103.438 13.7124C103.201 13.958 103.016 14.2512 102.895 14.5733C102.774 14.8955 102.72 15.2397 102.737 15.5841C102.721 15.9318 102.775 16.279 102.896 16.6047C103.017 16.9303 103.201 17.2275 103.438 17.4782C103.696 17.723 103.999 17.9123 104.33 18.0351C104.661 18.1579 105.013 18.2115 105.365 18.1927C105.717 18.2136 106.069 18.161 106.401 18.0381C106.732 17.9152 107.035 17.7247 107.292 17.4782Z" fill="white"/>
                <path d="M124.296 10.1254V14.3676C123.72 14.0182 123.057 13.8477 122.388 13.8772C121.362 13.8772 120.569 14.1967 120.018 14.8299C119.468 15.4632 119.193 16.4467 119.193 17.7804V21.3894H114.473V9.91523H119.096V13.5578C119.353 12.2241 119.768 11.2406 120.341 10.6073C120.618 10.2959 120.959 10.0495 121.339 9.88504C121.719 9.72057 122.129 9.64196 122.542 9.65464C123.159 9.63752 123.767 9.8009 124.296 10.1254Z" fill="white"/>
                <path d="M139.977 7.26758V21.3896H135.257V18.8118C134.901 19.7295 134.262 20.5045 133.435 21.0198C132.523 21.549 131.485 21.8127 130.435 21.7819C129.447 21.8053 128.475 21.5293 127.641 20.9889C126.834 20.4552 126.191 19.7006 125.786 18.8118C125.344 17.8307 125.124 16.7611 125.142 15.682C125.111 14.563 125.345 13.453 125.825 12.4457C126.266 11.523 126.954 10.746 127.809 10.2041C128.689 9.66152 129.701 9.38278 130.73 9.39989C132.975 9.39989 134.485 10.3937 135.257 12.3812V7.26758H139.977ZM134.563 17.4108C134.804 17.1697 134.993 16.8803 135.117 16.5609C135.242 16.2416 135.3 15.8993 135.287 15.5559C135.297 15.2228 135.238 14.8912 135.114 14.5831C134.989 14.2749 134.801 13.9972 134.563 13.7682C134.023 13.3206 133.348 13.0762 132.652 13.0762C131.956 13.0762 131.281 13.3206 130.741 13.7682C130.503 14.0025 130.317 14.285 130.194 14.5973C130.072 14.9097 130.015 15.2449 130.028 15.5811C130.016 15.9204 130.074 16.2586 130.198 16.5738C130.322 16.8889 130.51 17.1741 130.749 17.4108C131.002 17.6501 131.299 17.8356 131.623 17.9563C131.947 18.0771 132.292 18.1307 132.637 18.1141C132.988 18.1338 133.339 18.0818 133.67 17.961C134.001 17.8402 134.305 17.6531 134.563 17.4108Z" fill="white"/>
                <path d="M66.8356 11.1369C68.1353 11.1369 69.1888 10.1734 69.1888 8.98494C69.1888 7.79646 68.1353 6.83301 66.8356 6.83301C65.536 6.83301 64.4824 7.79646 64.4824 8.98494C64.4824 10.1734 65.536 11.1369 66.8356 11.1369Z" fill="white"/>
                <path d="M64.4795 12.6191C65.225 12.9381 66.0254 13.1024 66.8341 13.1024C67.6427 13.1024 68.4432 12.9381 69.1886 12.6191V21.451H64.4795V12.6191Z" fill="white"/>
                <path d="M31.3425 2.34496C28.9116 1.2337 26.3453 0.445332 23.7091 0C23.3484 0.643884 23.022 1.30636 22.7313 1.98464C19.9233 1.56215 17.0678 1.56215 14.2598 1.98464C13.969 1.30643 13.6426 0.643962 13.282 0C10.6442 0.449093 8.07618 1.23933 5.6428 2.35077C0.81191 9.48734 -0.497667 16.4467 0.157121 23.3072C2.98621 25.3943 6.15276 26.9815 9.51914 28C10.2772 26.982 10.9479 25.9021 11.5243 24.7717C10.4295 24.3634 9.37295 23.8598 8.36672 23.2665C8.63154 23.0747 8.89055 22.8771 9.14082 22.6853C12.0687 24.0602 15.2644 24.773 18.4999 24.773C21.7355 24.773 24.9311 24.0602 27.859 22.6853C28.1122 22.8917 28.3712 23.0892 28.6332 23.2665C27.625 23.8607 26.5664 24.3654 25.4698 24.7746C26.0454 25.9045 26.7162 26.9835 27.4749 28C30.8442 26.9856 34.0131 25.3991 36.8427 23.3101C37.611 15.3541 35.5303 8.4587 31.3425 2.34496ZM12.3537 19.088C10.529 19.088 9.0215 17.4346 9.0215 15.4006C9.0215 13.3665 10.4766 11.6986 12.3478 11.6986C14.2191 11.6986 15.7149 13.3665 15.6829 15.4006C15.6509 17.4346 14.2133 19.088 12.3537 19.088ZM24.6462 19.088C22.8186 19.088 21.317 17.4346 21.317 15.4006C21.317 13.3665 22.7721 11.6986 24.6462 11.6986C26.5204 11.6986 28.0046 13.3665 27.9725 15.4006C27.9405 17.4346 26.5058 19.088 24.6462 19.088Z" fill="white"/>
            </svg>
            </div>
            <div class="social-card discord-mobile" @click="openLink('https://discord.gg/MCSkQab2EB')">
                <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.0245 1.67497C20.3162 0.881212 18.5129 0.318094 16.6605 0C16.407 0.459917 16.1776 0.933111 15.9734 1.4176C14.0002 1.11582 11.9936 1.11582 10.0204 1.4176C9.81603 0.933161 9.58668 0.459973 9.33329 0C7.47969 0.32078 5.67515 0.885235 3.96521 1.67912C0.570531 6.77667 -0.349712 11.7476 0.11041 16.648C2.09842 18.1388 4.32356 19.2725 6.68913 20C7.22178 19.2729 7.69312 18.5015 8.09812 17.6941C7.32887 17.4025 6.5864 17.0427 5.87931 16.6189C6.06541 16.4819 6.24741 16.3408 6.42328 16.2038C8.48073 17.1859 10.7263 17.695 13 17.695C15.2736 17.695 17.5192 17.1859 19.5766 16.2038C19.7545 16.3512 19.9365 16.4923 20.1206 16.6189C19.4121 17.0434 18.6683 17.4038 17.8977 17.6961C18.3022 18.5032 18.7736 19.2739 19.3067 20C21.6743 19.2755 23.9011 18.1422 25.8895 16.6501C26.4294 10.9672 24.9672 6.04193 22.0245 1.67497ZM8.68094 13.6343C7.39874 13.6343 6.33944 12.4533 6.33944 11.0004C6.33944 9.54753 7.36193 8.35616 8.67685 8.35616C9.99178 8.35616 11.0429 9.54753 11.0204 11.0004C10.9979 12.4533 9.98769 13.6343 8.68094 13.6343ZM17.319 13.6343C16.0347 13.6343 14.9795 12.4533 14.9795 11.0004C14.9795 9.54753 16.002 8.35616 17.319 8.35616C18.6359 8.35616 19.6789 9.54753 19.6564 11.0004C19.6339 12.4533 18.6257 13.6343 17.319 13.6343Z" fill="white"/>
                </svg>
            </div>
            <div class="social-card tg" @click="openLink('https://t.me/cloudmodsss')">
                <svg width="138" height="24" viewBox="0 0 138 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7337 0.150734C23.0455 0.0172675 23.3868 -0.0287647 23.722 0.0174289C24.0572 0.0636225 24.3742 0.200353 24.6398 0.413388C24.9055 0.626424 25.1101 0.907977 25.2325 1.22874C25.3548 1.5495 25.3904 1.89776 25.3355 2.23724L22.4737 19.8904C22.1961 21.5933 20.359 22.5698 18.8233 21.7216C17.5388 21.012 15.631 19.9187 13.915 18.7779C13.0569 18.2069 10.4286 16.3783 10.7516 15.0771C11.0292 13.9646 15.4455 9.78384 17.9691 7.29825C18.9596 6.32172 18.5079 5.75839 17.3382 6.65664C14.4323 8.88687 9.76995 12.2784 8.22804 13.2331C6.86782 14.0749 6.15869 14.2186 5.31076 14.0749C3.7638 13.8131 2.32914 13.4076 1.15819 12.9136C-0.424105 12.2463 -0.347136 10.0341 1.15693 9.38989L22.7337 0.150734Z" fill="white"/>
                    <path d="M43.9677 19.2787H40.4014V5.94098H35.4085V2.7541H48.9606V5.94098H43.9677V19.2787Z" fill="white"/>
                    <path d="M60.2484 12.7869C60.2484 13.2118 60.2088 13.6446 60.1295 14.0852H51.4277C51.7288 15.8164 52.6481 16.682 54.1856 16.682C54.7879 16.682 55.2476 16.5797 55.5646 16.3751C55.8816 16.1548 56.1749 15.8243 56.4443 15.3836H60.0106C59.6778 16.5797 59.0359 17.5711 58.0848 18.358C57.1338 19.1292 55.8341 19.5148 54.1856 19.5148C52.2677 19.5148 50.754 18.9482 49.6445 17.8151C48.5508 16.6662 48.004 15.0689 48.004 13.0229C48.004 10.977 48.5508 9.38754 49.6445 8.25442C50.754 7.10557 52.2677 6.53115 54.1856 6.53115C55.3903 6.53115 56.4522 6.79869 57.3716 7.33377C58.2909 7.85311 58.9962 8.59278 59.4876 9.55278C59.9948 10.497 60.2484 11.5751 60.2484 12.7869ZM56.9911 11.7246C56.8643 11.0951 56.5553 10.5443 56.0639 10.0721C55.5884 9.6 54.9623 9.36393 54.1856 9.36393C53.4724 9.36393 52.8701 9.57639 52.3787 10.0013C51.9032 10.4105 51.5862 10.9849 51.4277 11.7246H56.9911Z" fill="white"/>
                    <path d="M65.9536 19.2787H62.625V2.7541H65.9536V19.2787Z" fill="white"/>
                    <path d="M80.5644 12.7869C80.5644 13.2118 80.5248 13.6446 80.4455 14.0852H71.7437C72.0448 15.8164 72.9642 16.682 74.5017 16.682C75.104 16.682 75.5636 16.5797 75.8806 16.3751C76.1976 16.1548 76.4909 15.8243 76.7603 15.3836H80.3267C79.9938 16.5797 79.3519 17.5711 78.4008 18.358C77.4498 19.1292 76.1501 19.5148 74.5017 19.5148C72.5838 19.5148 71.0701 18.9482 69.9605 17.8151C68.8669 16.6662 68.32 15.0689 68.32 13.0229C68.32 10.977 68.8669 9.38754 69.9605 8.25442C71.0701 7.10557 72.5838 6.53115 74.5017 6.53115C75.7063 6.53115 76.7683 6.79869 77.6876 7.33377C78.6069 7.85311 79.3122 8.59278 79.8036 9.55278C80.3108 10.497 80.5644 11.5751 80.5644 12.7869ZM77.3072 11.7246C77.1804 11.0951 76.8713 10.5443 76.3799 10.0721C75.9044 9.6 75.2783 9.36393 74.5017 9.36393C73.7884 9.36393 73.1861 9.57639 72.6947 10.0013C72.2192 10.4105 71.9022 10.9849 71.7437 11.7246H77.3072Z" fill="white"/>
                    <path d="M88.4094 24C86.6342 24 85.279 23.6144 84.3438 22.8433C83.4245 22.0879 82.7984 21.057 82.4655 19.7508H85.913C86.0239 20.16 86.3013 20.4748 86.7451 20.6951C87.1889 20.9311 87.7437 21.0492 88.4094 21.0492C89.2336 21.0492 89.8756 20.8525 90.3352 20.459C90.7949 20.0656 91.0247 19.5148 91.0247 18.8066V17.0361H90.9059C90.6047 17.4138 90.1609 17.7679 89.5744 18.0984C88.988 18.4131 88.3222 18.5705 87.5773 18.5705C85.9447 18.5705 84.645 18.0511 83.6781 17.0125C82.7112 15.958 82.2278 14.4708 82.2278 12.5508C82.2278 10.6308 82.7112 9.15147 83.6781 8.11279C84.645 7.05836 85.9447 6.53115 87.5773 6.53115C88.2905 6.53115 88.9404 6.68852 89.5269 7.00328C90.1133 7.31803 90.6126 7.71147 91.0247 8.1836H91.1436L91.5002 6.76721H94.3533V18.8066C94.3533 20.4905 93.8619 21.7731 92.8792 22.6544C91.8965 23.5515 90.4066 24 88.4094 24ZM88.2905 15.6197C89.1306 15.6197 89.7963 15.3443 90.2877 14.7934C90.779 14.2426 91.0247 13.4951 91.0247 12.5508C91.0247 11.6066 90.779 10.859 90.2877 10.3082C89.7963 9.75737 89.1306 9.48197 88.2905 9.48197C87.4505 9.48197 86.7848 9.75737 86.2934 10.3082C85.802 10.859 85.5564 11.6066 85.5564 12.5508C85.5564 13.4951 85.802 14.2426 86.2934 14.7934C86.7848 15.3443 87.4505 15.6197 88.2905 15.6197Z" fill="white"/>
                    <path d="M97.2175 19.2787V6.76721H100.071L100.427 8.1836H100.546C101.18 7.23934 102.171 6.76721 103.518 6.76721H105.063V9.95409H103.756C102.757 9.95409 101.973 10.2295 101.402 10.7803C100.831 11.3311 100.546 12.0787 100.546 13.0229V19.2787H97.2175Z" fill="white"/>
                    <path d="M111.617 6.53115C113.297 6.53115 114.604 6.94033 115.54 7.75869C116.491 8.57705 116.966 9.74164 116.966 11.2525V19.2787H114.113L113.756 17.8623H113.637C113.336 18.3029 112.9 18.6885 112.33 19.019C111.759 19.3495 111.046 19.5148 110.19 19.5148C108.843 19.5148 107.773 19.1528 106.98 18.4288C106.188 17.7049 105.792 16.7685 105.792 15.6197C105.792 14.4551 106.212 13.5187 107.052 12.8105C107.908 12.0866 109.112 11.7246 110.666 11.7246H113.637V11.1344C113.637 10.5521 113.447 10.1115 113.067 9.81246C112.686 9.51344 112.163 9.36393 111.498 9.36393C111.038 9.36393 110.634 9.46623 110.285 9.67082C109.952 9.87541 109.722 10.1272 109.596 10.4262H106.267C106.537 9.30885 107.115 8.38033 108.003 7.64065C108.906 6.90098 110.111 6.53115 111.617 6.53115ZM111.022 16.8C111.799 16.8 112.425 16.5875 112.9 16.1626C113.392 15.722 113.637 15.1475 113.637 14.4393V14.0852H110.784C110.23 14.0852 109.81 14.2111 109.524 14.4629C109.255 14.699 109.12 15.0059 109.12 15.3836C109.12 15.8085 109.279 16.1548 109.596 16.4223C109.913 16.6741 110.388 16.8 111.022 16.8Z" fill="white"/>
                    <path d="M119.693 19.2787V6.76721H122.546L122.903 8.1836H123.021C123.766 7.08196 124.757 6.53115 125.993 6.53115C126.738 6.53115 127.42 6.71213 128.038 7.0741C128.656 7.43606 129.124 7.92393 129.441 8.5377H129.56C129.861 7.95541 130.368 7.47541 131.081 7.0977C131.795 6.72 132.555 6.53115 133.364 6.53115C134.267 6.53115 135.068 6.73574 135.765 7.14492C136.478 7.53836 137.025 8.11279 137.406 8.86819C137.802 9.60787 138 10.4813 138 11.4885V19.2787H134.671V11.9607C134.671 11.1266 134.473 10.5049 134.077 10.0957C133.681 9.68655 133.166 9.48197 132.532 9.48197C131.961 9.48197 131.478 9.70229 131.081 10.1429C130.701 10.5679 130.511 11.1738 130.511 11.9607V19.2787H127.182V11.9607C127.182 11.1266 126.984 10.5049 126.588 10.0957C126.191 9.68655 125.676 9.48197 125.042 9.48197C124.472 9.48197 123.988 9.70229 123.592 10.1429C123.212 10.5679 123.021 11.1738 123.021 11.9607V19.2787H119.693Z" fill="white"/>
                </svg>
            </div>
            <div class="social-card tg-mobile" @click="openLink('https://t.me/cloudmodsss')">
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.514 0.136827C21.8091 0.0156744 22.1321 -0.0261108 22.4493 0.0158209C22.7666 0.0577525 23.0665 0.181868 23.3179 0.375248C23.5693 0.568629 23.763 0.824205 23.8788 1.11537C23.9946 1.40654 24.0282 1.72266 23.9762 2.03083L21.268 18.0553C21.0053 19.601 19.2667 20.4875 17.8135 19.7175C16.5979 19.0734 14.7924 18.0809 13.1684 17.0454C12.3564 16.5271 9.86912 14.8672 10.1748 13.6861C10.4375 12.6762 14.6169 8.88116 17.0051 6.6249C17.9424 5.73846 17.515 5.22711 16.408 6.04248C13.658 8.06695 9.2458 11.1456 7.78661 12.0122C6.49937 12.7763 5.82828 12.9068 5.02584 12.7763C3.56187 12.5387 2.20418 12.1706 1.09605 11.7222C-0.401352 11.1165 -0.328512 9.1083 1.09486 8.52356L21.514 0.136827Z" fill="white"/>
                </svg>
            </div>
        </div>
            <div class="social-wrapper">
                <div class="social-card vk" @click="openLink('https://vk.com/cloudmodscis')">
                    <svg width="161" height="28" viewBox="0 0 161 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1032_3615)">
                        <mask id="mask0_1032_3615" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="161" height="28">
                            <path d="M160.86 0H0.139893V28H160.86V0Z" fill="white"/>
                        </mask>
                        <g mask="url(#mask0_1032_3615)">
                            <path d="M48.8101 17.3718C48.8101 19.4975 46.8311 21.0367 44.0457 21.0367H37.5222V7.84302H43.8259C46.5379 7.84302 48.4436 9.30899 48.4436 11.3614C48.4436 12.754 47.7106 13.6336 46.6113 14.1467C47.7839 14.5865 48.8101 15.7593 48.8101 17.3718ZM40.3807 10.2619V13.1205H43.7525C44.7787 13.1205 45.4384 12.5341 45.4384 11.7278C45.4384 10.9216 44.7053 10.2619 43.7525 10.2619H40.3807ZM44.0457 18.6179C45.1452 18.6179 45.9516 17.9582 45.9516 17.0053C45.9516 16.0525 45.2186 15.3928 44.0457 15.3928H40.3807V18.6179H44.0457Z" fill="white"/>
                            <path d="M59.5851 20.9634L55.0407 15.7593H54.3076V20.9634H51.3755V7.84302H54.3076V12.9006H55.0407L59.4384 7.84302H62.8835L57.386 14.1467L63.3965 20.9634H59.5851Z" fill="white"/>
                            <path d="M63.3967 14.4398C63.3967 10.4817 66.3286 7.62305 70.4331 7.62305C74.5379 7.62305 77.4698 10.4817 77.4698 14.4398C77.4698 18.3979 74.5379 21.2566 70.4331 21.2566C66.3286 21.2566 63.3967 18.3979 63.3967 14.4398ZM74.3915 14.4398C74.3915 11.9477 72.7787 10.2618 70.4331 10.2618C68.0876 10.2618 66.475 11.9477 66.475 14.4398C66.475 16.932 68.0876 18.6178 70.4331 18.6178C72.7787 18.6178 74.3915 16.932 74.3915 14.4398Z" fill="white"/>
                            <path d="M88.6846 7.84302H91.6165V20.9634H88.6846V15.686H82.8206V20.9634H79.8887V7.84302H82.8206V13.0472H88.6846V7.84302Z" fill="white"/>
                            <path d="M97.9202 20.9634V10.4818H93.3755V7.84302H105.323V10.4818H100.779V20.9634H97.9202Z" fill="white"/>
                            <path d="M117.93 13.6335V20.9634H115.805L115.218 18.911C114.559 20.0105 113.166 21.2566 111.04 21.2566C108.402 21.2566 106.496 19.4974 106.496 17.0786C106.496 14.6597 108.402 12.9738 112.287 12.9738H115.145C114.999 11.288 114.119 10.1152 112.506 10.1152C111.187 10.1152 110.307 10.8482 109.868 11.6545L107.229 11.2147C107.889 8.94244 110.161 7.62305 112.653 7.62305C115.878 7.62305 117.93 9.822 117.93 13.6335ZM115.072 15.2461H112.36C110.161 15.2461 109.428 15.9791 109.428 16.932C109.428 18.0314 110.307 18.7644 111.773 18.7644C113.679 18.7644 115.072 17.3718 115.072 15.2461Z" fill="white"/>
                            <path d="M129.219 20.9634L124.674 15.7593H123.941V20.9634H121.009V7.84302H123.941V12.9006H124.674L129.072 7.84302H132.517L127.019 14.1467L133.03 20.9634H129.219Z" fill="white"/>
                            <path d="M138.308 20.9634V10.4818H133.763V7.84302H145.711V10.4818H141.166V20.9634H138.308Z" fill="white"/>
                            <path d="M160.37 15.2461H149.815C150.109 17.2984 151.575 18.6178 153.773 18.6178C155.313 18.6178 156.486 17.9581 157.145 17.0053L159.857 17.4451C158.904 19.9372 156.339 21.2566 153.554 21.2566C149.596 21.2566 146.737 18.3979 146.737 14.4398C146.737 10.4817 149.596 7.62305 153.554 7.62305C157.512 7.62305 160.37 10.4817 160.37 14.2932C160.444 14.6597 160.37 14.9529 160.37 15.2461ZM150.035 12.9738H157.292C156.779 11.3613 155.459 10.1885 153.627 10.1885C151.868 10.1152 150.475 11.288 150.035 12.9738Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.10814 1.96824C0.139893 3.93649 0.139893 7.10433 0.139893 13.44V14.56C0.139893 20.8957 0.139893 24.0635 2.10814 26.0318C4.07639 28 7.24422 28 13.5799 28H14.6999C21.0356 28 24.2034 28 26.1717 26.0318C28.1399 24.0635 28.1399 20.8957 28.1399 14.56V13.44C28.1399 7.10433 28.1399 3.93649 26.1717 1.96824C24.2034 0 21.0356 0 14.6999 0H13.5799C7.24422 0 4.07639 0 2.10814 1.96824ZM4.86495 8.51673C5.0166 15.7967 8.65657 20.1717 15.0382 20.1717H15.4V16.0067C17.745 16.24 19.5182 17.9551 20.2298 20.1717H23.5433C22.6333 16.8584 20.2415 15.0267 18.7482 14.3267C20.2415 13.4634 22.3415 11.3634 22.8432 8.51673H19.8331C19.1798 10.8267 17.2433 12.9267 15.4 13.125V8.51673H12.3899V16.59C10.5232 16.1234 8.1666 13.8601 8.0616 8.51673H4.86495Z" fill="white"/>
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0_1032_3615">
                            <rect width="161" height="28" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                </div>
                <div class="social-card vk-mobile" @click="openLink('https://vk.com/cloudmodscis')">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.82765 1.82765C0 3.65531 0 6.59688 0 12.48V13.52C0 19.4031 0 22.3447 1.82765 24.1724C3.65531 26 6.59688 26 12.48 26H13.52C19.4031 26 22.3447 26 24.1724 24.1724C26 22.3447 26 19.4031 26 13.52V12.48C26 6.59688 26 3.65531 24.1724 1.82765C22.3447 0 19.4031 0 13.52 0H12.48C6.59688 0 3.65531 0 1.82765 1.82765ZM4.38755 7.90839C4.52837 14.6684 7.90834 18.7309 13.8342 18.7309H14.1701V14.8634C16.3476 15.08 17.9941 16.6726 18.6549 18.7309H21.7317C20.8867 15.6542 18.6658 13.9534 17.2791 13.3034C18.6658 12.5017 20.6158 10.5517 21.0816 7.90839H18.2865C17.6799 10.0534 15.8817 12.0034 14.1701 12.1875V7.90839H11.375V15.405C9.64166 14.9717 7.45337 12.8701 7.35587 7.90839H4.38755Z" fill="white"/>
                    </svg>
                </div>
                <div class="social-card youtube" @click="openLink('https://www.youtube.com/@cloudmodsofficial')">
                    <svg width="124" height="26" viewBox="0 0 124 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1032_3632)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.4105 0.874482C37.0991 1.29994 38.4349 2.55266 38.8885 4.1363C39.7202 7.01994 39.7454 12.9999 39.7454 12.9999C39.7454 12.9999 39.7454 19.0036 38.9137 21.8636C38.4601 23.4472 37.1243 24.6999 35.4357 25.1254C32.3861 25.9054 20.1121 25.9054 20.1121 25.9054C20.1121 25.9054 7.83811 25.9054 4.78852 25.1254C3.0999 24.6999 1.76413 23.4472 1.31047 21.8636C0.47876 18.9799 0.47876 12.9999 0.47876 12.9999C0.47876 12.9999 0.47876 7.01994 1.28526 4.15994C1.73892 2.5763 3.07469 1.32357 4.76331 0.898119C7.81291 0.118119 20.0869 0.0944824 20.0869 0.0944824C20.0869 0.0944824 32.3609 0.0944824 35.4105 0.874482ZM26.3625 12.9999L16.1804 18.5308V7.46903L26.3625 12.9999Z" fill="white"/>
                            <path d="M57.4382 23.5653C56.6569 23.069 56.1024 22.3126 55.7748 21.2726C55.4471 20.2326 55.2959 18.8617 55.2959 17.1362V14.7962C55.2959 13.0708 55.4723 11.6526 55.8504 10.6126C56.2284 9.54898 56.8081 8.79261 57.6146 8.31989C58.4211 7.84716 59.4544 7.58716 60.7398 7.58716C62 7.58716 63.0333 7.82352 63.7894 8.31989C64.5455 8.81625 65.1252 9.57261 65.478 10.6126C65.8309 11.6526 66.0073 13.0472 66.0073 14.7726V17.1126C66.0073 18.8381 65.8309 20.209 65.478 21.249C65.1252 22.289 64.5707 23.0453 63.7894 23.5417C63.0081 24.0144 61.9496 24.2744 60.639 24.2744C59.278 24.2981 58.2195 24.0381 57.4382 23.5653ZM61.7983 21.0362C62.0252 20.5162 62.126 19.6417 62.126 18.4599V13.4253C62.126 12.2672 62.0252 11.4162 61.7983 10.8962C61.5715 10.3526 61.1935 10.0926 60.6642 10.0926C60.1349 10.0926 59.7821 10.3526 59.5553 10.8962C59.3284 11.4399 59.2276 12.2672 59.2276 13.4253V18.4599C59.2276 19.6417 59.3284 20.5162 59.53 21.0362C59.7317 21.5562 60.1097 21.8162 60.6642 21.8162C61.1935 21.8162 61.5715 21.5562 61.7983 21.0362Z" fill="white"/>
                            <path d="M117.044 17.1835V18.0108C117.044 19.0508 117.069 19.8308 117.145 20.3508C117.22 20.8708 117.346 21.249 117.548 21.4853C117.75 21.7217 118.077 21.8399 118.506 21.8399C119.085 21.8399 119.489 21.6272 119.69 21.2017C119.917 20.7762 120.018 20.0672 120.043 19.0981L123.395 19.2872C123.42 19.429 123.42 19.6181 123.42 19.8544C123.42 21.3435 122.992 22.4544 122.11 23.1872C121.228 23.9199 120.018 24.2981 118.43 24.2981C116.515 24.2981 115.179 23.7308 114.423 22.6199C113.667 21.509 113.263 19.7599 113.263 17.4199V14.5599C113.263 12.149 113.667 10.3762 114.448 9.26534C115.254 8.15443 116.615 7.58716 118.531 7.58716C119.867 7.58716 120.875 7.82352 121.581 8.27261C122.286 8.7217 122.79 9.4308 123.093 10.3999C123.395 11.369 123.521 12.6926 123.521 14.3944V17.1599H117.044V17.1835ZM117.548 10.3763C117.346 10.6126 117.22 10.9672 117.145 11.4872C117.069 12.0072 117.044 12.7872 117.044 13.8508V15.009H119.867V13.8508C119.867 12.8108 119.841 12.0308 119.766 11.4872C119.69 10.9435 119.564 10.5653 119.363 10.3526C119.161 10.1399 118.859 10.0217 118.455 10.0217C118.027 10.0453 117.724 10.1635 117.548 10.3763Z" fill="white"/>
                            <path d="M48.0121 16.8764L43.6016 1.93823H47.4577L48.9951 8.69823C49.3983 10.3764 49.6755 11.7946 49.8772 12.9528H49.978C50.104 12.1019 50.4064 10.7073 50.8601 8.72187L52.4479 1.93823H56.304L51.843 16.8528V24.0146H48.0373V16.8764H48.0121Z" fill="white"/>
                            <path d="M78.5082 7.89453V24.0382H75.4838L75.1561 22.0527H75.0805C74.2488 23.5418 73.0139 24.2982 71.3757 24.2982C70.2415 24.2982 69.3846 23.9436 68.8553 23.2345C68.3009 22.5254 68.0488 21.4382 68.0488 19.9491V7.89453H71.9301V19.7363C71.9301 20.4454 72.0057 20.9654 72.1822 21.2727C72.3586 21.58 72.6358 21.7218 73.0139 21.7218C73.3415 21.7218 73.6692 21.6273 73.9716 21.4382C74.274 21.2491 74.5009 20.9891 74.6521 20.7054V7.89453H78.5082Z" fill="white"/>
                            <path d="M98.3934 7.89453V24.0382H95.369L95.0414 22.0527H94.9658C94.1341 23.5418 92.8991 24.2982 91.2609 24.2982C90.1268 24.2982 89.2699 23.9436 88.7406 23.2345C88.1861 22.5254 87.9341 21.4382 87.9341 19.9491V7.89453H91.8154V19.7363C91.8154 20.4454 91.891 20.9654 92.0674 21.2727C92.2438 21.58 92.5211 21.7218 92.8991 21.7218C93.2268 21.7218 93.5544 21.6273 93.8568 21.4382C94.1593 21.2491 94.3861 20.9891 94.5373 20.7054V7.89453H98.3934Z" fill="white"/>
                            <path d="M89.043 4.86914H85.1869V24.0382H81.4064V4.86914H77.5503V1.93823H89.0178V4.86914H89.043Z" fill="white"/>
                            <path d="M111.197 10.4708C110.97 9.45448 110.592 8.72175 110.063 8.24902C109.533 7.79993 108.828 7.56357 107.895 7.56357C107.189 7.56357 106.509 7.75266 105.904 8.13084C105.274 8.50902 104.82 9.00539 104.467 9.61993H104.442V1.11084H100.712V24.0145H103.913L104.316 22.4781H104.392C104.694 23.0218 105.148 23.4472 105.728 23.7781C106.332 24.0854 106.988 24.2508 107.719 24.2508C109.029 24.2508 109.987 23.6836 110.617 22.549C111.222 21.4145 111.55 19.6418 111.55 17.2545V14.7018C111.55 12.9054 111.424 11.4872 111.197 10.4708ZM107.643 17.0654C107.643 18.2472 107.593 19.169 107.492 19.8308C107.391 20.4927 107.215 20.9654 106.963 21.249C106.711 21.5327 106.383 21.6745 105.98 21.6745C105.652 21.6745 105.375 21.6036 105.098 21.4618C104.82 21.3199 104.619 21.1072 104.442 20.8236V11.6527C104.568 11.2036 104.795 10.849 105.123 10.5654C105.45 10.2817 105.778 10.1399 106.156 10.1399C106.559 10.1399 106.862 10.2817 107.063 10.5654C107.29 10.849 107.416 11.3454 107.517 12.0308C107.593 12.7163 107.643 13.6854 107.643 14.9618V17.0654Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1032_3632">
                                <rect width="124" height="26" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="social-card youtube-mobile" @click="openLink('https://www.youtube.com/@cloudmodsofficial')">
                    <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.6881 0.604396C27.9782 0.934066 28.9987 1.90476 29.3453 3.13187C29.9807 5.3663 30 10 30 10C30 10 30 14.652 29.3646 16.8681C29.018 18.0952 27.9974 19.0659 26.7073 19.3956C24.3774 20 15 20 15 20C15 20 5.62259 20 3.29268 19.3956C2.00257 19.0659 0.982028 18.0952 0.63543 16.8681C0 14.6337 0 10 0 10C0 10 0 5.3663 0.616175 3.15018C0.962773 1.92308 1.98331 0.952381 3.27343 0.622711C5.60334 0.018315 14.9807 0 14.9807 0C14.9807 0 24.3582 0 26.6881 0.604396ZM19.7755 9.99983L11.9963 14.2855V5.71411L19.7755 9.99983Z" fill="white"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<style scoped>
.socials {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
}

.social-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.social-title {
    font-style: normal;
    font-weight: 600;
    color: var(--text-primary);
}

.social-desc {
    color: rgba(255, 255, 255, 0.60);
    font-weight: 500;
}

.socials-text-container {
    display: flex;
    flex-direction: column;
}

.social-card {
    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid rgba(255, 255, 255, 0.10);
    background: #040404;
    transition: 0.25s ease;
}

.social-wrapper-container {
    display: flex;
    flex-direction: column;
}

.social-wrapper {
    display: flex;
    flex-direction: row;
}

@media (min-width: 320px) {
    .social-card.discord {
        display: none;
    }

    .social-card.vk {
        display: none;
    }

    .social-card.tg {
        display: none;
    }

    .social-card.youtube {
        display: none;
    }

    .socials {
        height: 149.6875vw;
    }

    .social-image {
        width: 90vw;
        height: 59.375vw;
        background-image: url("@/assets/images/benefits/socials_320.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 3.75vw;
    }

    .social-container {
        flex-direction: column;
        align-items: flex-start;
        width: 90vw;
        gap: 5vw;
    }

    .socials-text-container {
        gap: 2.1875vw;
    }

    .social-title {
        font-size: 6.25vw;
        width: 50vw;
    }

    .social-desc {
        width: 77.5vw;
        font-size: 4.6875vw;
    }

    .social-card {
        width: 43.4375vw;
        height: 14.375vw;
        border-radius: 3.5vw;
    }

    .social-wrapper-container {
        gap: 3.125vw;
    }

    .social-wrapper {
        flex-direction: row;
        gap: 3.125vw;
    }
}

@media (min-width: 464px) {
    .socials {
        height: 296px;
    }

    .social-image {
        width: 464px;
        height: 190px;
        background-image: url("@/assets/images/socials_mobile.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 12px;
    }

    .social-container {
        align-items: center;
        flex-direction: row;
        width: 464px;
        gap: normal;
    }

    .socials-text-container {
        gap: 16px;
    }

    .social-title {
        width: auto;
        font-size: 20px;
    }

    .social-desc {
        width: 288px;
        font-size: 15px;
    }

    .social-card {
        width: 69px;
        height: 48px;
        border-radius: 12px;
    }

    .social-wrapper-container {
        gap: 10px;
    }

    .social-wrapper {
        flex-direction: row;
        gap: 10px;
    }
}

@media (min-width: 744px) {
    .socials {
        height: 465px;
    }

    .social-image {
        width: 744px;
        height: 325px;
        background-image: url("@/assets/images/socials1244.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .social-container {
        width: 744px;
    }

    .socials-text-container {
        gap: 19px;
    }

    .social-title {
        font-size: 26px;
    }

    .social-desc {
        width: 403px;
        font-size: 21px;
    }

    .social-card {
        width: 114px;
        height: 64px;
        border-radius: 12px;
    }

    .social-wrapper-container {
        gap: 12px;
    }

    .social-wrapper {
        gap: 12px;
    }
}

@media (min-width: 984px) {
    .social-card.discord-mobile {
        display: none;
    }

    .social-card.vk-mobile {
        display: none;
    }

    .social-card.tg-mobile {
        display: none;
    }

    .social-card.youtube-mobile {
        display: none;
    }

    .social-card.discord {
        display: flex;
    }

    .social-card.vk {
        display: flex;
    }

    .social-card.tg {
        display: flex;
    }

    .social-card.youtube {
        display: flex;
    }

    .socials {
        height: 465px;
    }

    .social-image {
        width: 984px;
        height: 325px;
        background-image: url("@/assets/images/socials1244.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .social-container {
        width: 984px;
    }

    .socials-text-container {
        gap: 19px;
    }

    .social-title {
        font-size: 28px;
    }

    .social-desc {
        width: 403px;
        font-size: 21px;
    }

    .social-card {
        width: 237px;
        height: 64px;
        border-radius: 12px;
    }

    .social-wrapper-container {
        gap: 12px;
    }

    .social-wrapper {
        gap: 12px;
    }
}

@media (min-width: 1248px) {
    .socials {
        height: 542px;
    }

    .social-image {
        width: 1248px;
        height: 380px;
        background-image: url("@/assets/images/socials1244.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .social-container {
        width: 1248px;
    }

    .socials-text-container {
        gap: 24px;
    }

    .social-title {
        font-size: 32px;
    }

    .social-desc {
        width: 617px;
        font-size: 24px;
    }

    .social-card {
        width: 303px;
        height: 76px;
        border-radius: 12px;
    }

    .social-wrapper-container {
        gap: 12px;
    }

    .social-wrapper {
        gap: 12px;
    }
}

.social-card.vk:hover {
    background-color: #0077FF;
    cursor: pointer;
}

.social-card.discord:hover {
    background-color: #5865F2;
    cursor: pointer;
}

.social-card.youtube:hover {
    background-color: #FF0000;
    cursor: pointer;
}

.social-card.tg:hover {
    background-color: #2AABEE;
    cursor: pointer;
}

</style>